import CryptoJS from 'crypto-js';
import type { BrandKey } from '@/models/configuration';

async function fallbackDecrypt(content: string, KEY: string, IV: string): Promise<string> {
  const key = CryptoJS.enc.Utf8.parse(KEY);
  const iv = CryptoJS.enc.Utf8.parse(IV);

  const decrypted = CryptoJS.AES.decrypt(content, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
}

async function nativeDecrypt(content: string, KEY: string, IV: string): Promise<string> {
  const keyData = new TextEncoder().encode(KEY);
  const ivData = new TextEncoder().encode(IV);
  const encryptedData = Uint8Array.from(atob(content), (c) => c.charCodeAt(0));

  const cryptoKey = await crypto.subtle.importKey('raw', keyData, { name: 'AES-CBC' }, false, ['decrypt']);

  const decryptedBuffer = await crypto.subtle.decrypt({ name: 'AES-CBC', iv: ivData }, cryptoKey, encryptedData);

  return new TextDecoder().decode(decryptedBuffer);
}

export async function decrypt(content: string, KEY: string, IV: string): Promise<string> {
  try {
    return await nativeDecrypt(content, KEY, IV);
  } catch {
    return await fallbackDecrypt(content, KEY, IV);
  }
}

export async function getKeyIv(brand: BrandKey = 'ryuryu', env = ''): Promise<{ key: string; iv: string }> {
  if (env !== 'prod') {
    return {
      key: 'f64b091f7ebc9f26',
      iv: '9b7c2d45f9e2a8c7',
    };
  }

  switch (brand.toLowerCase()) {
    case 'wangyou':
      return {
        key: 'q@h7rYDXK(6CATdx',
        iv: '59oka@H0$jr5kHzc',
      };
    default:
      return {
        key: 'f64b7ebc9f26091f',
        iv: 'd45f9e2a8c79b7c2',
      };
  }
}
